export default "https://assets.egbcdn.net/assets/packs/_/images/b-day/bg-a9404fd30f8c020021de2b7e8f350a8e.svg";